import React from 'react';

export default ({ children }) => (
	<div
        css={{
            background: 'white',
            width: '100%',
            height: '100%',
        }}
    >
	    {children}
	</div>
);
